import { useState } from "react";
import { useDispatch } from "react-redux";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { updateProfileThunk } from "redux/slices/authenticationSlice";
import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import WithAuthWrapper from "withWrapper/withAuthWrapper";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("stmpz-token") || "";
  const [new_password, setNewPassword] = useState<string>("");
  const [confirm_password, setConfirmPassword] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const editProfile = async () => {
    if (password === "" || new_password === "") {
      alert("All fields are required!");
      return;
    }
    if (new_password !== confirm_password) {
      alert("Confirm Password is not match with New Password ");
      return;
    }
    try {
      await dispatch(
        updateProfileThunk({
          accessToken,
          old_password: password,
          new_password
        })
      );
    } catch (e) {
      console.log(e);
    } finally {
      setNewPassword("");
      setConfirmPassword("");
      setPassword("");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDTypography
        variant="h4"
        fontWeight="medium"
        mt={1}
        p={3}
        textAlign="center"
      >
        Change Password
      </MDTypography>

      <MDBox pt={2} pb={3} px={3} bgColor="white" borderRadius="lg" p={5}>
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Old Password"
              value={password}
              fullWidth
              onChange={(event) => setPassword(event.target.value)}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="New Password"
              value={new_password}
              fullWidth
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Confirm Password"
              value={confirm_password}
              fullWidth
              onChange={(event) => setConfirmPassword(event.target.value)}
            />
          </MDBox>
          <MDBox mt={4} mb={1}>
            <MDButton
              variant="gradient"
              color="primary"
              fullWidth
              onClick={editProfile}
            >
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
};

export default WithAuthWrapper(ProfilePage);
